import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import i18n from '@/libs/i18n'
import { getGroups } from '@/composables/groupService'

export default function useGroupsList() {

    const toast = useToast()
    const refGroupListTable = ref(null)

    // Table Handlers
    const tableColumns = [
        { key: 'group', label: i18n.t('Group'), sortable: true },
        { key: 'cif', label: 'CIF' },
        { key: 'phone', label: 'Teléfono' },
        { key: 'address', label: 'Direccion', sortable: true },
        { key: 'series', label: 'Series' },
        { key: 'status', label: i18n.t('Status'), sortable: true },
        { key: 'actions', label: i18n.t('Actions') },
    ]
    const perPage = ref(10)
    const totalGroups = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const statusFilter = ref(null)

    const dataMeta = computed(() => {
        const localItemsCount = refGroupListTable.value ? refGroupListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalGroups.value,
        }
    })

    const refetchData = () => {
        refGroupListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchData()
    })

    // const fetchGroups = (ctx, callback) => {
    //     store
    //         .dispatch('groups/fetchGroups', {
    //             q: searchQuery.value,
    //             perPage: perPage.value,
    //             page: currentPage.value,
    //             sortBy: sortBy.value,
    //             sortDesc: isSortDirDesc.value,
    //             status: statusFilter.value,
    //         })
    //         .then(response => {
    //             const { groups, total } = response.data
    //             callback(groups)
    //             totalGroups.value = total
    //         })
    //         .catch(() => {
    //             toast({
    //                 component: ToastificationContent,
    //                 props: {
    //                     title: 'Error fetching group list',
    //                     icon: 'AlertTriangleIcon',
    //                     variant: 'danger',
    //                 },
    //             })
    //         })
    // }

    const fetchGroups = async function () {
            let data = {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
                status: statusFilter.value,
            }
            let response = await getGroups(data);
            const { groups, total } = response.data
            totalGroups.value = total
            return groups
    }

    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*

    const resolveGroupStatusVariant = status => {
        if (status === true) return 'success'
        if (status === false) return 'secondary'
        return 'primary'
    }

    return {
        fetchGroups,
        tableColumns,
        perPage,
        currentPage,
        totalGroups,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refGroupListTable,
        resolveGroupStatusVariant,
        refetchData,
        statusFilter,
    }
}